import { createContentGroupAction } from "fleet/redux-store/content-groups/actions";
import {
  contentGroupUpdateContentAction,
  contentGroupUpdateNameAction,
} from "fleet/redux-store/ui-state/content-group-form";
import { ContentGroupModal } from "fleet/view/media-library/content-group-modal";
import { connect } from "react-redux";
import { filterByProperty, makeGetAllAsArray } from "redux-store";

const getAllUserContentsAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const { global, pages } = state;
  const userContents = getAllUserContentsAsArray(
    filterByProperty(global.userContents, "archived", false),
  );
  return {
    userContents,
    content: pages.contentGroupForm.content,
    name: pages.contentGroupForm.name,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createContentGroup: (group) => {
      dispatch(createContentGroupAction(group, "Content Group created!"));
    },
    updateContent: (content) => {
      dispatch(contentGroupUpdateContentAction(content));
    },
    updateName: (name) => {
      dispatch(contentGroupUpdateNameAction(name));
    },
  };
}

const ConnectedContentGroupModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentGroupModal);

export { ConnectedContentGroupModal };
